document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js"

/**
 * Needed for SmoothScroll on page load
 * - prevents page jump on load
 */
if (window.location.hash) { setTimeout(function () { window.scrollTo(0, 0); }, 2); }

jQuery(document).ready(function ($) {
    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

    //Load images, and images after doc ready
    var lazyLoadImages = (function () {
        var $lazyImages = $('img[data-src], iframe[data-src], [data-background]');
        if (!$lazyImages.length) { return; }

        function init() {
            $lazyImages.each(function () {
                var $this = $(this),
                    delay = 0,
                    dataSrc;
                if (dataSrc = $this.data('background')) {
                    if ($this.data('background-delay')) {
                        delay = $this.data('background-delay');
                    }
                    setTimeout(function () {
                        $this.css('background-image', 'url(' + dataSrc + ')');
                        $this.attr('data-background', null);
                    }, delay);
                } else if (dataSrc = $this.data('src')) {
                    if ($this.data('src-delay')) {
                        delay = $this.data('src-delay');
                    }
                    setTimeout(function () {
                        $this.attr('src', dataSrc);
                        $this.attr('data-src', null);
                    }, delay);
                }
            });
        }
        init();
        return { init: init }
    }());

    //Global function to grab parameters from url
    var urlParams = (function (strParam) {
        var objParams = {};

        function init() {
            objParams = {};
            var arrURLParams = window.location.search.replace('?', '').split('&');
            arrURLParams.map(function (val) {
                var arrPair = val.split('=');
                objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
            });
        }
        init();
        return {
            get: function (strParam) { return objParams[strParam]; },
            pull: init
        }
    }());

    //Global function to smooth scroll inside pages
    var SmoothScroll = (function () {
        var $anchorLinks = $('a[href^="#"]');

        function goTo(target) {
            if (target === "" || !$(target).length) { return; }
            var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

            if (window.innerWidth >= 720) {
                scrollPos -= $('.gheader').outerHeight();
            } else {
                scrollPos -= $('.gheader').outerHeight() * 2;
            }

            $('html, body').stop().animate({
                'scrollTop': scrollPos
            }, 1200, 'swing', function () {
                if (typeof target === 'string') {

                    if (window.location.hash) {
                        window.location.hash = target;
                    }
                }
            });
        }

        if (window.location.hash) {
            setTimeout(function () {
                goTo(window.location.hash);
            }, 500);
        }

        if ($anchorLinks.length) {
            $anchorLinks.on('click', function (e) {
                if (!$("#" + this.hash.replace('#', '')).length) { return; }
                e.preventDefault();
                goTo(this.hash);
            });
        }

        return { to: goTo }
    }());

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            $this = $(this).find('.accordion__trigger');
            if ($this.hasClass('active')) {
                $this.next().slideToggle(250);
            }
        });
        $(document).on('click', '.accordion__trigger', function () {
            var $this = $(this);
            $this.toggleClass('active');
            $this.next().slideToggle(250);
            $this.parent().siblings().find('.accordion__trigger').removeClass('active').next().slideUp(250);
        });
    }());

    //
    var InputMasks = (function () {
        var $masks = $('[data-mask]');
        if (!$masks.length) { return; }

        $('[data-mask]').keyup(function (e) {
            switch (this.dataset.mask) {
                case 'phone':
                    var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    console.log(x);
                    this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                    break;
                case 'ssn':
                    var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                    this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                    break;
            }
        });
    }());

    //Plugin used for form validation
    var parselyOptions = {
        classHandler: function (parsleyField) {
            var $element = parsleyField.$element;
            if ($element.parent().hasClass('select-menu')) {
                return $element.parent();
            }
            return $element;
        },
        errorsContainer: function (parsleyField) {
            var $element = parsleyField.$element;
            var $fieldContainer = $element.closest('.form-field');
            if ($fieldContainer) {
                return $fieldContainer;
            }
        }
    };

    //Global function to set form state classes
    var formStates = (function () {
        $formInputs = $('main form :input');
        if (!$formInputs.length) { return; }

        $formSelectMenus = $('.select-menu select, .ginput_container_select select');

        function isGFormInput($el) {
            return $el.parent().hasClass('ginput_container') ? $el.parent() : $el;
        }

        function setFilled($input) {
            var $parent = $input;

            $parent.addClass('filled');
        }

        function removeFilled($input) {
            var $parent = $input;

            $parent.removeClass('filled');
        }

        function setFocused() {
            var $parent = $(this);

            $parent.addClass('focused');
        }

        function removeFocused() {
            var $parent = $(this);

            $parent.removeClass('focused');
        }

        function checkInput(e) {
            if (this.type == 'button' ||
                this.type == 'range' ||
                this.type == 'submit' ||
                this.type == 'reset') { return; }

            var $this = $(this);
            var $parent = $this.parent();
            var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

            var $input = is_selectMenu ? $parent : $this;

            switch (this.type) {
                case 'select-one':
                case 'select-multiple':
                    if (this.value !== '') {
                        setFilled($input);
                    } else {
                        removeFilled($input);
                    }
                    break;
                default:
                    if (this.value) {
                        setFilled($input);
                    } else {
                        removeFilled($input);
                    }
                    break;
            }
        }

        $formInputs.each(checkInput);
        $formInputs.on('change', checkInput);
        $formInputs.on('focus', setFocused);
        $formInputs.on('blur', removeFocused);
        $formSelectMenus.on('focus', setFocused);
        $formSelectMenus.on('blur', removeFocused);

    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {

            e.preventDefault();

            var iframe = $(this).data('lightbox-iframe');

            if (iframe) {
                $lightbox_content.html('<div class="vid-wrap">' + iframe + '</div>');
            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                } else {
                    var content = $(this).next('.lightbox-content').html();
                }
                $lightbox_content.html(content);
            }

            var classes = $(this).data('lightbox-classes');
            $lightbox.addClass('active').addClass(classes);

        });

        function closeLightbox($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        $('.pdm-lightbox').on('click', function (e) {
            var $lightbox = $(this);
            if (e.target == this) {
                closeLightbox($lightbox);
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            $lightbox = $(this).closest('.pdm-lightbox');
            closeLightbox($lightbox);
        });
        return {
            close: closeLightbox
        };
    }());

    var DropdownMenus = (function () {
        var $menus = $('.menu');
        var $dropmenus = $menus.find('.dropdown.menu-item');
        var $mobileArrow = $dropmenus.find('.mobile-arrow');

        function toggleDropdown(e) {
            e.preventDefault();

            var $this = $(this);
            var $menuItem = $this.closest('.dropdown');

            $dropmenus.not($menuItem).removeClass('active');

            if ($menuItem.hasClass('active')) {
                $menuItem.removeClass('active');
            } else {
                $menuItem.addClass('active');
            }
        }

        $mobileArrow.click(toggleDropdown);
    }());

    var Header = (function () {
        var $body = $('body');
        var $header = $('header.gheader');
        var $nav = $header.find('.menu-container');

        var BurgerMenu = (function () {
            var $burgerMenu = $header.find('.menu-burger');
            var $text = $burgerMenu.find('.menu-burger__text');

            function activate() {
                $burgerMenu.addClass('active').attr('title', 'Close');
                $text.text('Close');
                SearchMenu.close();
                $nav.addClass('active');
                $body.addClass('no-scroll');
            }

            function reset() {
                $burgerMenu.removeClass('active').attr('title', 'Menu');
                $text.text('Menu');
                SearchMenu.close();
                $nav.removeClass('active').find('.active').removeClass('active');
                $body.removeClass('no-scroll');
            }

            $burgerMenu.click(function () {
                var $this = $(this);

                if ($this.hasClass('active')) { reset(); } else { activate(); }
            });
        }());

        var SearchMenu = (function () {
            var $searchOpen = $('.open-search');
            var $searchMenu = $('.search-menu');
            var $searchClose = $('.close-search');

            function openSearch() {
                $searchMenu.addClass('active').find('[type="text"]').focus();
                $body.addClass('no-scroll');
            }

            function closeSearch() {
                $searchMenu.removeClass('active');
                $body.removeClass('no-scroll');
            }

            $searchOpen.click(openSearch);
            $searchClose.click(closeSearch);

            return {
                open: openSearch,
                close: closeSearch
            }
        }());

        var NextSection = (function () {
            var $btn = $('#next-section');
            var $nextSection = $body.find('main > section');

            if (!$nextSection.length) { $btn.hide(); return; }

            $btn.click(function () {
                SmoothScroll.to($nextSection.offset().top);
            });
        }());

        var StickHeader = (function () {
            var $headerHeight = $header.innerHeight();
            var $nextElm = $header.next();
            var $nextElmHeight = $nextElm.innerHeight() / 2;
            var lastScrollPos = window.pageYOffset;

            var isSticky = true;
            var autoHide = false;
            var $adminBar = $('#wpadminbar');

            if (isSticky && !$header.hasClass('nosticky')) {
                if (autoHide) {
                    $header.addClass('autohide');
                }

                $(window).on('scroll', function () {
                    curScrollPos = window.pageYOffset;

                    if (window.scrollY >= 20) {
                        $header.addClass('sticky');
                        $nextElm.css({ marginTop: $headerHeight });

                        if ($adminBar.length) {
                            $header.css({ marginTop: $adminBar.innerHeight() })
                        }

                        if (autoHide) {
                            $header.css({
                                top: (curScrollPos > lastScrollPos) ? -$headerHeight : 0
                            });
                        }
                    } else if (window.scrollY === 0) {
                        $header.removeClass('sticky').css({ marginTop: 0 });
                        $nextElm.css({ marginTop: 0 });

                        if (autoHide) {
                            $header.css({ top: 0 });
                        }
                    }

                    lastScrollPos = window.pageYOffset;
                });
            }
        }());
    }());

    var loadMorePosts = (function () {
        var $loadMoreButton = $('.load-more-btn');
        if (!$loadMoreButton.length) { return; }

        var $loadMore = $('.load-more-container');
        var $loadMoreContainer = $loadMore.find('.container');

        function ajaxPosts(target, replace) {
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url: target,
                success: function (response) {
                    //					console.log(response);
                    if (replace == true) {
                        $loadMoreContainer.html($(response).find('.load-more-container').html());
                    } else {
                        $loadMoreContainer.append($(response).find('.load-more-container article'));
                    }

                    if ($(response).find('.load-more-btn').length) {
                        if ($loadMoreButton.length) {
                            $loadMoreButton.html($(response).find('.load-more-btn').html());
                        }
                    } else {
                        if ($loadMoreButton.length) {
                            $loadMoreButton.remove();
                        }
                    }

                    lazyLoadImages.init();
                    setTimeout(function () {
                        $loadMore.removeClass('loading');
                        lazyLoadImages.init();
                    }, 250);
                }
            });
        }
        $loadMore.on('click', '.load-more-btn a', function (e) {
            e.preventDefault();
            $(this).addClass('loading');
            var target = $(this).attr('href');
            ajaxPosts(target, false);

        });

    }());

    var Blog = (function () {
        var $blog = $('.blog');
        if (!$blog) { return; }
        var CategorySelection = (function () {
            var $section = $('.categories');
            if (!$section.length) { return; }

            var $selectMenu = $section.find('.categories__list');
            var $goBtn = $section.find('.btn');

            $selectMenu.change(function () {
                var $this = $(this);
                var url = '#';
                if ($this.val() !== '') {
                    $goBtn.attr('href', '/blog/category/' + $this.val());
                }
            })
        }());
    }());

    var LogoSlider = (function () {
        var $section = $('.logoslider');
        if (!$section.length) { return; }

        var $slider = $section.find('.slider');
        $slider.slick({
            mobileFirst: true,
            dots: false,
            arrows: false,
            slidesToShow: 2,
            autoplay: true,
            appendArrows: $section.find('.slider-arrows'),
            responsive: [{
                breakpoint: 720,
                settings: {
                    autoplay: false,
                    arrows: true,
                    slidesToShow: 5,
                }
            }]
        })
    }());

    var CTATestimonials = (function () {
        var $section = $('.cta-testimonials');
        if (!$section.length) { return; }

        var $slider = $section.find('.slider');
        $slider.slick({
            mobileFirst: true,
            dots: true,
            arrows: false,
            autoplay: true,
            appendArrows: $section.find('.slider-arrows'),
            appendDots: $section.find('.slider-dots'),
            adaptiveHeight: true,
            responsive: [{
                breakpoint: 1100,
                settings: {
                    autoplay: false,
                    arrows: true,
                }
            }]
        })
    }());

    var SearchFilter = (function () {
        var $section = $('.search-results');
        if (!$section.length) { return; }

        var $filters = $section.find('[name="search-filter"]');
        $filters.change(function () {
            var $activeFilters = $section.find('[name="search-filter"]:checked');
            var $results = $section.find('.search-card');

            $results.addClass('hidden');

            if ($activeFilters.length) {
                $activeFilters.each(function () {
                    $results.filter('[data-type="' + this.value + '"]').removeClass('hidden');
                });
            } else {
                $results.removeClass('hidden');
            }
        });
    }());

    var GallerySlider = (function () {
        var $section = $('.gallery');
        if (!$section.length) { return; }

        var $slider = $section.find('.slider');
        $slider.slick({
            mobileFirst: true,
            dots: true,
            arrows: true,
            appendArrows: $section.find('.slider-arrows'),
            appendDots: $section.find('.slider-dots')
        })
    }());

    var GlossaryFilter = (function () {
        var $section = $('.glossary');
        if (!$section.length) { return; }

        var $select = $section.find('#glossary-filter');
        $select.change(function () {
            SmoothScroll.to('#' + this.value);
        });

    }());

    var FreeTrialPopup = (function () {
        var $popup = $('.free-trial');
        if (!$popup) { return; }

        var $trigger = $('.freetrial-trigger').add('[href*="#start"]');
        var $close = $popup.find('.close-freetrial');

        var $steps = $popup.find('.free-trial-step');
        var $progressStep = $popup.find('.free-trial-progress__current');

        $trigger.click(function () {
            console.log('click');
            $popup.addClass('active');
            $('body').addClass('no-scroll');
        });

        $close.click(function () {
            $popup.removeClass('active');
            $('body').removeClass('no-scroll');
        });

        $(document).on('gform_page_loaded', function (event, form_id, current_page) {
            $steps.removeClass('active').eq(current_page - 1).addClass('active');
            $progressStep.text(current_page);
        });

    }());

    var VideoBlock = (function () {
        var $section = $('.videoblock');
        if (!$section.length) { return; }

        var $cover = $section.find('.vid-wrap__cover');
        var $embed = $section.find('iframe');
        $cover.click(function () {
            $(this).remove();
            $embed.attr('src', $embed.attr('src') + '&autoplay=1');
        });
    }());

    var Calculators = (function () {
        var $section = $('.calcblock');
        if (!$section.length) { return; }

        var $form = $section.find('form');
        var form_name = $form.attr('id').replace('calc-', '');
        var _Parsley = $form.parsley();

        var $result = $section.find('#result');

        function calcDim() {
            var carriers = [{ name: 'usps', rate: 166 }, { name: 'fedex', rate: 139 }];

            if (_Parsley.validate()) {
                var $length = Math.round($section.find('#length').val() * 100) / 100;
                var $width = Math.round($section.find('#width').val());
                var $height = Math.round($section.find('#height').val());
                var $carrier = $section.find('#carrier').val();

                var filtered = carriers.filter(function (x) {
                    return x.name === $carrier ? x.rate : false;
                });

                var rate = filtered.length ? filtered[0].rate : false;

                var result = Math.round(($length * $width * $height) / rate);

                $result.text(result);
            }
        }

        $form.submit(function (e) {
            e.preventDefault();

            switch (form_name) {
                case 'dim':
                    calcDim();
                    break;
            }
        });

        $form.on('reset', function () {
            $result.text('0');
        });
    }());
    
    

    AOS.init({
        delay: 250,
        once: true,
        disable: 'mobile'
    });

});